import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import BackButton from "../buttons/BackButton";
import AddIcon from "@material-ui/icons/Add";
import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { InputAdornment } from "@mui/material";
import { withRouter } from "../../../withRouter";
import TextField from "@material-ui/core/TextField";
import { Autocomplete } from "@mui/material";
import store from "../../../redux/store";
import Utils from "../../../provider/Utils";
import MenuWithBreadScrum from "../menu/MenuWithBreadScrum";
import {
  GetGroup_Url,
  getListWithAllActives,
  AllGroupList_Url,
} from "../../../provider/ServiceUrl";
import FetchServerData from "../../../provider/FetchServerData";
import PtsAlert from "../ptsAlert/PtsAlert";
import { BUSINESS_DOMAIN } from "../../../provider/Enums";
import Pagination from "../pagination/Pagination";
import _ from "lodash";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";
import BackIconButton from "../buttons/BackIconButton";

class ContactFromOtherGroup extends Component {
  header = store.getState().header.header;
  businessDomain =
    store.getState().appUserData.appUserData.appuser?.businessDomain;
  businessDomainId = store.getState().businessDomain?.businessDomainId;
  title = "Move contacts to target group";
  givbeeBreadCrumb = [
    { pageid: "/groups", uiname: "Groups" },
    { pageid: "/group", uiname: "Group Details" },
    { pageid: "", uiname: "Add from Other Groups" },
  ];
  eventBreadCrumb = [
    { pageid: "/eventGroups", uiname: "Groups" },
    { pageid: "/eventGroup", uiname: "Group Details" },
    { pageid: "", uiname: "Add from Other Groups" },
  ];
  dptextBreadCrumb = [
    { pageid: "/dptextGroups", uiname: "Groups" },
    { pageid: "/dptextGroup", uiname: "Group Details" },
    { pageid: "", uiname: "Add from Other Groups" },
  ];
  constructor(props) {
    super(props);
    let targetGroupName = "";
    let targetGroupId = "";
    if (props.state) {
      targetGroupName = props.state.targetGroupName;
      targetGroupId = props.state.targetGroupId;
    }

    let breadCrumb = [];
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      breadCrumb = this.eventBreadCrumb;
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      breadCrumb = this.dptextBreadCrumb;
    } else {
      breadCrumb = this.givbeeBreadCrumb;
    }
    this.state = {
      breadCrumb: breadCrumb,
      targetGroupName: targetGroupName,
      targetGroupId: targetGroupId,
      initialPage: 0,
      pageSize: 20,
      smsGroupList: [],
      smsContactList: [],
      smsGroup: null,
      isPaging: false,
      isSelected: false,
      isCtrlPressed: false,
      isShiftPressed: false,
      render: false,
      isAscSort: false,
      sortColumn: "lastMessageSenton",
      sortDirection: "asc",
      selectedTab: 0,
    };
    this.debouncedSearch = _.debounce(this.getContactsList, 800);
  }

  componentDidMount() {
    window.addEventListener("keydown", this.handleKeyDown);
    window.addEventListener("keyup", this.handleKeyUp);
    this.getAllOptinContactList();
    this.getActivityContactList();
  }

  getListWithAllActives() {
    const postObject = {
      header: this.header,
      event: {
        id: this.businessDomainId,
      },
    };
    FetchServerData.callPostService(AllGroupList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let smsGroupList = output.data.groupList;
          let newGroupList = [];
          for (let i = 0; i < smsGroupList.length; i++) {
            const group = smsGroupList[i];
            if (group.id !== this.state.targetGroupId) {
              newGroupList.push(group);
            }
          }
          let smsGroup = Utils.getArrayElement(newGroupList, 0);
          this.getContactsList(smsGroup, 0, 20);
          this.setState({
            render: true,
            smsGroupList: newGroupList,
            smsGroup: smsGroup,
          });
        } else {
        }
      }
    );
  }
  getActivityContactList() {
    const postObject = {
      header: this.header,
      event: {
        id: this.businessDomainId,
      },
    };
    FetchServerData.callPostService("/quickTextms/getGroupActivityList", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let smsActivityList = output.data.activityList;
          const filteredList = this.state.smsActivityList
            ?.filter(opt => opt.messageKeyword && opt.messageKeyword.trim() !== "")
            .sort((a, b) => a.messageKeyword.localeCompare(b.messageKeyword));
          const messageName = smsActivityList[0] || null;
          const messageKeyword = filteredList?.[0] || null;
          if (this.state.selectedTab === 3) {
            this.getActivityContactsList(messageName);
            this.setState({
              render: true,
              smsActivityList: smsActivityList,
              messageName: messageName,
            });
          } else if (this.state.selectedTab === 4) {
            this.getActivityContactsList(messageKeyword);
            this.setState({
              render: true,
              smsActivityList: smsActivityList,
              messageKeyword: messageKeyword
            });
          } else {
            this.setState({
              render: true,
              smsActivityList: smsActivityList,
              messageKeyword: messageKeyword
            });
          }
        } else {
        }
      }
    );
  }

  handleKeyDown = (event) => {
    if (event.key === "Control") {
      this.setState({ isCtrlPressed: true });
    } else if (event.key === "Shift") {
      this.setState({ isShiftPressed: true });
    }
  };

  handleKeyUp = (event) => {
    if (event.key === "Control") {
      this.setState({ isCtrlPressed: false });
    } else if (event.key === "Shift") {
      this.setState({ isShiftPressed: false });
    }
  };

  getContactsList(smsGroup, pageNo, pageSize, sortBy, isAscSort) {
    const postObject = {
      header: this.header,
      smsGroup: {
        id: smsGroup?.id,
        event: {
          id: this.businessDomainId,
        },
      },
      page: {
        searchText:
          this.state.searchText !== undefined ? this.state.searchText : "",
        pageNo: pageNo ? pageNo : this.state.initialPage,
        pageSize: pageSize ? pageSize : this.state.pageSize,
        sortBy: sortBy,
        isAscSort: isAscSort,
      },
    };

    FetchServerData.callPostService(GetGroup_Url, postObject).then((output) => {
      if (output.status === "SUCCESS") {
        let smsContactList = output.data.smsGroup?.contactList;
        let page = output.data.page;
        let isPaging = false;
        if (smsContactList.length > this.state.pageSize) {
          isPaging = true;
        }
        for (let i = 0; i < smsContactList.length; i++) {
          smsContactList[i].mobile = Utils.viewTollFreeNumberFormate(
            smsContactList[i].mobile
          );
          smsContactList[i].lastMessageSenton = Utils.getUtcToLocalDateTime(
            smsContactList[i].lastMessageSenton
          );
        }
        this.setState({
          render: true,
          isPaging: isPaging,
          initialPage: this.state.initialPage,
          smsContactList: smsContactList,
          pageNo: page.pageNo,
          showPerPage: page.pageSize,
          totalPages: page.totalPages,
          totalRecords: page.total,
        });
      } else {
      }
    });
  }
  getActivityContactsList(activity, pageNo, pageSize, sortBy, isAscSort) {
    const postObject = {
      header: this.header,
      activityId: activity?.id,
      event: {
        id: this.businessDomainId,
      },
      page: {
        searchText:
          this.state.searchText !== undefined ? this.state.searchText : "",
        pageNo: pageNo ? pageNo : this.state.initialPage,
        pageSize: pageSize ? pageSize : this.state.pageSize,
        sortBy: sortBy,
        isAscSort: isAscSort,
      },
    };

    FetchServerData.callPostService("/activityMs/getContacts", postObject).then((output) => {
      if (output.status === "SUCCESS") {
        let smsContactList = output.data?.contactList;
        let page = output.data.page;
        let isPaging = false;
        if (smsContactList.length > this.state.pageSize) {
          isPaging = true;
        }
        for (let i = 0; i < smsContactList.length; i++) {
          smsContactList[i].mobile = Utils.viewTollFreeNumberFormate(
            smsContactList[i].mobile
          );
          smsContactList[i].lastMessageSenton = Utils.getUtcToLocalDateTime(
            smsContactList[i].lastMessageSenton
          );
        }
        this.setState({
          render: true,
          isPaging: isPaging,
          initialPage: this.state.initialPage,
          smsContactList: smsContactList,
          pageNo: page.pageNo,
          showPerPage: page.pageSize,
          totalPages: page.totalPages,
          totalRecords: page.total,
        });
      } else {
      }
    });
  }

  getAllPendingContactList(pageNo, pageSize, sortBy, isAscSort) {
    const postObject = {
      header: this.header,
      eventId: this.businessDomainId,
      page: {
        searchText:
          this.state.searchText !== undefined ? this.state.searchText : "",
        pageNo: pageNo ? pageNo : this.state.initialPage,
        pageSize: pageSize ? pageSize : this.state.pageSize,
        sortBy: sortBy,
        isAscSort: isAscSort,
      },
    };
    FetchServerData.callPostService(
      "/smscontactms/getPendingContactList",
      postObject
    )
      .then((output) => {
        if (output.status === "SUCCESS") {
          let smsContactList = output.data?.smsContactList;
          let page = output.data.page;
          let isPaging = false;
          if (smsContactList.length > this.state.pageSize) {
            isPaging = true;
          }
          for (let i = 0; i < smsContactList.length; i++) {
            smsContactList[i].mobile = Utils.viewTollFreeNumberFormate(
              smsContactList[i].mobile
            );
            smsContactList[i].lastMessageSenton = Utils.getUtcToLocalDateTime(
              smsContactList[i].lastMessageSenton
            );
          }
          this.setState({
            render: true,
            isPaging: isPaging,
            initialPage: this.state.initialPage,
            smsContactList: smsContactList,
            pageNo: page.pageNo,
            showPerPage: page.pageSize,
            totalPages: page.totalPages,
            totalRecords: page.total,
          });
        } else {
        }
      })
      .catch((error) => { });
  }
  getAllOptinContactList(pageNo, pageSize, sortBy, isAscSort) {
    const postObject = {
      header: this.header,
      eventId: this.businessDomainId,
      page: {
        searchText:
          this.state.searchText !== undefined ? this.state.searchText : "",
        pageNo: pageNo ? pageNo : this.state.initialPage,
        pageSize: pageSize ? pageSize : this.state.pageSize,
        sortBy: sortBy,
        isAscSort: isAscSort,
      },
    };
    FetchServerData.callPostService(
      "/smscontactms/getOptinContactList",
      postObject
    )
      .then((output) => {
        if (output.status === "SUCCESS") {
          let smsContactList = output.data?.smsContactList;
          let page = output.data.page;
          let isPaging = false;
          if (smsContactList.length > this.state.pageSize) {
            isPaging = true;
          }
          for (let i = 0; i < smsContactList.length; i++) {
            smsContactList[i].mobile = Utils.viewTollFreeNumberFormate(
              smsContactList[i].mobile
            );
            smsContactList[i].lastMessageSenton = Utils.getUtcToLocalDateTime(
              smsContactList[i].lastMessageSenton
            );
          }
          this.setState({
            render: true,
            isPaging: isPaging,
            initialPage: this.state.initialPage,
            smsContactList: smsContactList,
            pageNo: page.pageNo,
            showPerPage: page.pageSize,
            totalPages: page.totalPages,
            totalRecords: page.total,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  handleSearchByChange(e) {
    this.setState({
      searchBy: e.target.value,
    });

    if (e.target.value === "group") {
      this.getListWithAllActives()
    } else if (e.target.value === "OptIn") {
      this.getAllOptinContactList()
    } else if (e.target.value === "Pending") {
      this.getAllPendingContactList()
    } else {
      this.getActivityContactList()
    }
  }

  handleGroupsChange(selectedValue) {
    this.setState({
      smsGroup: selectedValue,
    });
    this.getContactsList(selectedValue);
  }

  handleMessageNameChange(selectedValue) {
    this.setState({
      messageName: selectedValue,
      activity: selectedValue,
    });
    this.getActivityContactsList(selectedValue);
  }
  handleMessageKeywordChange(selectedValue) {
    this.setState({
      messageKeyword: selectedValue,
      activity: selectedValue,
    });
    this.getActivityContactsList(selectedValue);
  }

  handleMaterialTablePageChange(page, pageSize) {
    this.setState({ initialPage: page, pageSize: pageSize });
  }

  rowItemSelected(rowData, e) {
    const { isCtrlPressed, isShiftPressed } = this.state;
    let selectedItems = this.state.smsContactList;
    if (isCtrlPressed || isShiftPressed) {
      let firstItemIndex = selectedItems.findIndex(
        (e) => e.id === rowData[0].id
      );
      let lastItem = selectedItems.indexOf(rowData[rowData.length - 1]);
      for (let i = firstItemIndex; i <= lastItem; i++) {
        selectedItems[i].isSelected = true;
        selectedItems[i].tableData.checked = true;
      }
    } else {
      for (let i = 0; i < selectedItems.length; i++) {
        if (rowData.id === selectedItems[i].id) {
          if (e.target.checked) {
            selectedItems[i].isSelected = true;
          } else {
            selectedItems[i].isSelected = false;
          }
        }
      }
    }

    this.setState({
      smsContactList: [...selectedItems],
      isSelected: rowData?.length > 0 ? true : false,
    });
  }

  addMultipleContactFromGroup() {
    let addSmsContactList = [];
    for (let i = 0; i < this.state.smsContactList.length; i++) {
      if (this.state.smsContactList[i]?.checked === true) {
        if (this.state.selectedTab === 0 || this.state.selectedTab === 1) {
          addSmsContactList.push({ id: this.state.smsContactList[i]?.id });
        } else {
          addSmsContactList.push({ id: this.state.smsContactList[i]?.contactId });
        }
      }
    }
    const postObject = {
      header: this.header,
      smsGroup: {
        id: this.state.targetGroupId,
      },
      smsContactList: addSmsContactList,
    };
    FetchServerData.callPostService(
      "/smsGroupContactms/addContactsToGroup",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        // let smsGroup = output.data.smsGroup;
        PtsAlert.success(output.message);
        if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
          this.props.navigate("/eventGroup", {
            state: {
              action: "view",
              groupId: this.state.targetGroupId,
            },
          });
        } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
          this.props.navigate("/dptextGroup", {
            state: {
              action: "view",
              groupId: this.state.targetGroupId,
            },
          });
        } else {
          this.props.navigate("/group", {
            state: {
              action: "view",
              groupId: this.state.targetGroupId,
            },
          });
        }
        this.setState({
          isSelected: false,
        });
      }
    });
  }

  viewCancel() {
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      this.props.navigate("/eventGroup", {
        state: {
          action: "view",
          groupId: this.state.targetGroupId,
        },
      });
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      this.props.navigate("/dptextGroup", {
        state: {
          action: "view",
          groupId: this.state.targetGroupId,
        },
      });
    } else {
      this.props.navigate("/group", {
        state: {
          action: "view",
          groupId: this.state.targetGroupId,
        },
      });
    }
  }

  onPaginationChange(returnProp) {
    let counter = returnProp.counter;
    let pageNo = this.state.pageNo + counter;
    let pageSize = returnProp.showPerPage;
    let buttonIndex = returnProp.buttonIndex;
    let currentPageIndex =
      typeof counter !== "undefined" ? pageNo : buttonIndex;
    let resetPageNo = returnProp.resetPageNo;
    if (resetPageNo === true) {
      currentPageIndex = 0;
    }
    let dataRows = this.state.smsContactList;
    for (let i = 0; i < dataRows.length; i++) {
      dataRows[i].checked = false;
      this.setState({
        allCheckBoxSelected: false,
        isSelected: false,
      });
    }
    this.setState({
      pageNo: currentPageIndex,
      pageSize: pageSize,
    });

    if (this.state.selectedTab === 2) {
      this.getContactsList(this.state.smsGroup, currentPageIndex, pageSize);
    } else if (this.state.selectedTab === 0) {
      this.getAllOptinContactList(currentPageIndex, pageSize)
    } else if (this.state.selectedTab === 1) {
      this.getAllPendingContactList(currentPageIndex, pageSize)
    } else {
      this.getActivityContactsList(this.state.activity, currentPageIndex, pageSize);
    }

  }

  onSearchChange(e) {
    this.setState({ searchText: e.target.value });
    this.debouncedSearch(
      this.state.smsGroup,
      this.state.pageNo,
      this.state.pageSize
    );
  }

  onCheckBoxSelect(e, rowData, index) {
    const { isCtrlPressed, isShiftPressed } = this.state;
    let selectedItems = this.state.smsContactList;
    if (isCtrlPressed || isShiftPressed) {
      let firstItemIndex;
      for (let i = 0; i < selectedItems.length; i++) {
        const element = selectedItems[i];
        if (element.checked === true) {
          firstItemIndex = i;
          break;
        }
      }

      let lastItem = index;
      if (firstItemIndex > lastItem) {
        let tempt = lastItem;
        lastItem = firstItemIndex;
        firstItemIndex = tempt;
      }

      for (let i = firstItemIndex; i <= lastItem; i++) {
        selectedItems[i].checked = true;
      }
    } else {
      for (let i = 0; i < selectedItems.length; i++) {
        if (rowData.id === selectedItems[i].id) {
          if (e.target.checked) {
            selectedItems[i].checked = true;
          } else {
            selectedItems[i].checked = false;
            this.setState({
              allCheckBoxSelected: false,
            });
          }
        }
      }
    }
    const allChecked = selectedItems.every((item) => item.checked);

    const anyChecked = selectedItems.some((item) => item.checked);
    this.setState({
      smsContactList: [...selectedItems],
      allCheckBoxSelected: allChecked,
      isSelected: anyChecked,
    });
  }

  onAllCheckBoxSelect(e) {
    let isChecked = e.target.checked;
    let dataRows = this.state.smsContactList;
    for (let i = 0; i < dataRows.length; i++) {
      const row = dataRows[i];
      this.onCheckBoxSelect(e, row, i);
    }
    this.setState({
      allCheckBoxSelected: isChecked,
    });
  }

  handleRowClick = (e, rowData, index) => {
    if (e.target.closest(".action-button")) return; // Skip if clicking action button

    const { isCtrlPressed, isShiftPressed } = this.state;

    // Determine list key and allSelected key based on status

    let selectedItems = [...this.state.smsContactList];

    if (isCtrlPressed || isShiftPressed) {
      // Multi-select range logic
      const firstItemIndex = selectedItems.findIndex((item) => item.checked);
      let lastItemIndex = index;

      if (firstItemIndex !== -1) {
        // Swap if needed
        const [start, end] =
          firstItemIndex < lastItemIndex
            ? [firstItemIndex, lastItemIndex]
            : [lastItemIndex, firstItemIndex];

        for (let i = start; i <= end; i++) {
          selectedItems[i].checked = true;
        }
      } else {
        // If no first checked item, just toggle current row
        selectedItems[index].checked = !selectedItems[index].checked;
      }
    } else {
      // Toggle single row selection
      selectedItems[index].checked = !selectedItems[index].checked;
    }

    // Calculate overall selection states
    const allChecked = selectedItems.every((item) => item.checked);
    const anyChecked = selectedItems.some((item) => item.checked);
    this.setState({
      smsContactList: selectedItems,
      allCheckBoxSelected: allChecked,
      isSelected: anyChecked,
    });
  };

  handleSort(column) {
    const { sortColumn, sortDirection, pageNo, pageSize } = this.state;
    const newDirection =
      sortColumn === column && sortDirection === "asc" ? "desc" : "asc";

    const isAscSort = newDirection === "asc";
    const activity = this.state.selectedTab === 3 ? this.state.messageName : this.state.messageKeyword
    this.setState(
      {
        sortColumn: column,
        sortDirection: newDirection,
        isAscSort: isAscSort,
      },
      () => {
        if (this.state.selectedTab === 2) {
          this.getContactsList(this.state.smsGroup, pageNo, pageSize, column, isAscSort);
        } else if (this.state.selectedTab === 0) {
          this.getAllOptinContactList(pageNo, pageSize, column, isAscSort)
        } else if (this.state.selectedTab === 1) {
          this.getAllPendingContactList(pageNo, pageSize, column, isAscSort)
        } else {
          this.getActivityContactsList(activity, pageNo, pageSize, column, isAscSort);
        }
      }
    );
  }

  setKey = (index) => {
    this.setState({ selectedTab: index });

    if (index === 0) this.getAllOptinContactList();
    if (index === 1) this.getAllPendingContactList();
    if (index === 2) this.getListWithAllActives(this.state.smsGroup, 0, 20);
    if (index === 3) this.getActivityContactList();
    if (index === 4) this.getActivityContactList();
  };

  renderTable(type) {
    return (
      <>
        <div className="table-responsive paginationTable">
          <table className="table text-start table-hover">
            <thead className="paginationTableThead">
              <tr>
                <th scope="col fw-bold">
                  <input
                    type="checkbox"
                    style={{
                      width: "15px",
                      height: "15px",
                      marginTop: "6px",
                      alignSelf: "center",
                    }}
                    checked={this.state.allCheckBoxSelected}
                    onChange={this.onAllCheckBoxSelect.bind(this)}
                  />
                </th>
                <th className="cursor-pointer" scope="col fw-bold" onClick={() => this.handleSort("mobile")}>Mobile Number
                  {this.state.sortColumn === "mobile" &&
                    (this.state.sortDirection === "asc" ? (
                      <i
                        class="fa fa-long-arrow-up ps-1"
                        aria-hidden="true"
                      ></i>
                    ) : (
                      <i class="fa-solid fa-arrow-down-long ps-1"></i>
                    ))}
                </th>
                <th className="cursor-pointer" scope="col fw-bold cursor-pointer" onClick={() => this.handleSort("firstName")}>First Name
                  {this.state.sortColumn === "firstName" &&
                    (this.state.sortDirection === "asc" ? (
                      <i
                        class="fa fa-long-arrow-up ps-1"
                        aria-hidden="true"
                      ></i>
                    ) : (
                      <i class="fa-solid fa-arrow-down-long ps-1"></i>
                    ))}
                </th>
                <th className="cursor-pointer" scope="col fw-bold" onClick={() => this.handleSort("lastName")}>Last Name
                  {this.state.sortColumn === "lastName" &&
                    (this.state.sortDirection === "asc" ? (
                      <i
                        class="fa fa-long-arrow-up ps-1"
                        aria-hidden="true"
                      ></i>
                    ) : (
                      <i class="fa-solid fa-arrow-down-long ps-1"></i>
                    ))}
                </th>
                <th className="cursor-pointer" scope="col fw-bold cursor-pointer" onClick={() => this.handleSort("email")}>Email
                  {this.state.sortColumn === "email" &&
                    (this.state.sortDirection === "asc" ? (
                      <i
                        class="fa fa-long-arrow-up ps-1"
                        aria-hidden="true"
                      ></i>
                    ) : (
                      <i class="fa-solid fa-arrow-down-long ps-1"></i>
                    ))}
                </th>
                <th className="cursor-pointer" scope="col fw-bold cursor-pointer" onClick={() => this.handleSort("lastMessageSenton")}>Most Recent Activity
                  {this.state.sortColumn === "lastMessageSenton" &&
                    (this.state.sortDirection === "asc" ? (
                      <i
                        class="fa fa-long-arrow-up ps-1"
                        aria-hidden="true"
                      ></i>
                    ) : (
                      <i class="fa-solid fa-arrow-down-long ps-1"></i>
                    ))}
                </th>
              </tr>
            </thead>
            <tbody>
              {this.state.smsContactList?.map((rowData, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor:
                      rowData.id === this.state.contactId
                        ? "#FEF5E7"
                        : "",
                    cursor: "pointer",
                  }}
                  onClick={(e) =>
                    this.handleRowClick(e, rowData, index)
                  }
                >
                  <td>
                    <input
                      type="checkbox"
                      style={{
                        width: "15px",
                        height: "15px",
                        marginTop: "6px",
                        alignSelf: "center",
                      }}
                      checked={
                        rowData.checked ||
                        this.state.allCheckBoxSelected
                      }
                      onChange={(e) =>
                        this.onCheckBoxSelect(e, rowData, index)
                      }
                    />
                  </td>
                  <td style={{ width: "260px" }}>{rowData.mobile}</td>
                  <td style={{ width: "260px" }}>{rowData.firstName}</td>
                  <td style={{ width: "260px" }}>{rowData.lastName}</td>
                  <td style={{ width: "260px" }}>{rowData.email}</td>
                  <td style={{ width: "260px" }}>{rowData.lastMessageSenton}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {
          this.state.totalRecords === 0 && (
            <div
              className="row text-center"
              style={{ padding: "6px 20px" }}
            >
              <h5 className="dataNotAvailable">
                There are no contacts in this group.
              </h5>
            </div>
          )
        }
        {
          this.state.totalRecords > 10 && (
            <div className="row justify-content-between pagination p-1">
              <div className="d-flex col-12 col-lg-4 col-xl-4">
                <div className="pageSize col-12 text-start">
                  {/* Page {this.state.pageNo + 1} of {this.state.totalPages} */}
                  Contacts: {Utils.formatWithCommas(this.state.totalRecords)}
                </div>
              </div>
              <div className="d-flex col-12 col-lg-8 col-xl-8">
                <div className="col-12 text-end">
                  <Pagination
                    showPerPage={this.state.showPerPage}
                    onPaginationChange={this.onPaginationChange.bind(
                      this
                    )}
                    total={this.state.totalRecords}
                  />
                </div>
              </div>
            </div>
          )
        }
      </>
    )
  }

  render() {
    if (this.state.render === false) {
      return <div />;
    }
    return (
      <>
        <MenuWithBreadScrum
          breadCrumb={this.state.breadCrumb}
          history={this.props.history}
          name={`Add Contacts into: ${this.state.targetGroupName}`}
          pageId="viewPage"
          groupId={this.state.targetGroupId}
        />

        <div style={{ maxWidth: "100%" }}>
          <Tabs
            defaultIndex={this.state.selectedTab}
            onSelect={(k) => this.setKey(k)}
          >
            <TabList
              style={{ listStyle: "none" }}
              className="text-start d-flex flex-wrap justify-content-start settingTabList ps-0 m-0"
            >
              <>
                <Tab className="tabContacts hoverTab">Opt-ins</Tab>
                <Tab className="tabContacts hoverTab">Pending</Tab>
                <Tab className="tabContacts hoverTab">Group</Tab>
                <Tab className="tabContacts hoverTab">Messages Sent</Tab>
                <Tab className="tabContacts hoverTab">Keywords Used</Tab>
              </>
            </TabList>
            <TabPanel>
              <div className="row">
                <div className="col">
                  <div className="col md-12">
                    <div className="card rounded-0">
                      <div
                        className="row justify-content-between"
                        style={{ padding: "0.6em 1.2rem", height: "56px" }}
                      >
                        <div className="d-flex col-12 col-lg-4 col-xl-4">
                          <div className="col-12 d-flex">
                            <span className="totalResults me-4" style={{ fontSize: "14px" }}>
                              Contacts: {Utils.formatWithCommas(this.state.totalRecords)}
                            </span>
                          </div>
                        </div>
                        <div className="d-flex col-12 col-lg-8 col-xl-8 text-end align-self-center">
                          <div className="col-sm-12 text-end align-self-center">
                            {this.state.isSelected && (
                              <Button
                                id="ptsGreenSolidButton"
                                type="submit"
                                className="btn btn-default "
                                startIcon={<AddIcon />}
                                onClick={this.addMultipleContactFromGroup.bind(this)}
                              >
                                Add contacts to target group
                              </Button>
                            )} &nbsp; &nbsp;
                            <span className="me-1">
                              <TextField
                                id="standard-search"
                                placeholder="Search"
                                type="text"
                                variant="standard"
                                value={this.state.searchText}
                                onChange={this.onSearchChange.bind(this)}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <IconButton
                                        onClick={this.state.searchBys === "Group" ? this.getContactsList.bind(
                                          this,
                                          this.state.smsGroup,
                                          this.state.pageNo,
                                          this.state.pageSize
                                        ) : this.getActivityContactsList.bind(
                                          this,
                                          this.state.activity,
                                          this.state.pageNo,
                                          this.state.pageSize
                                        )}
                                      >
                                        <SearchIcon />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        onClick={() => {
                                          this.setState({ searchText: "" }, () => {
                                            this.state.selectedTab === 2 ? this.getContactsList.bind(
                                              this,
                                              this.state.smsGroup,
                                              this.state.pageNo,
                                              this.state.pageSize
                                            ) : this.getActivityContactsList.bind(
                                              this,
                                              this.state.activity,
                                              this.state.pageNo,
                                              this.state.pageSize
                                            )
                                          });
                                        }}
                                        disabled={!this.state.searchText}
                                      >
                                        <ClearIcon
                                          style={{
                                            opacity: this.state.searchText ? 1 : 0.4,
                                            fontSize: "1.25rem",
                                            color: "#353538",
                                          }}
                                        />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                      {this.renderTable("optins")}
                    </div>
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div className="row">
                <div className="col">
                  <div className="col md-12">
                    <div className="card rounded-0">
                      <div
                        className="row justify-content-between"
                        style={{ padding: "0.6em 1.2rem", height: "56px" }}
                      >
                        <div className="d-flex col-12 col-lg-4 col-xl-4">
                          <div className="col-12 d-flex">
                            <span className="totalResults me-4" style={{ fontSize: "14px" }}>
                              Contacts: {Utils.formatWithCommas(this.state.totalRecords)}
                            </span>
                          </div>
                        </div>
                        <div className="d-flex col-12 col-lg-8 col-xl-8 text-end align-self-center">
                          <div className="col-sm-12 text-end align-self-center">
                            {this.state.isSelected && (
                              <Button
                                id="ptsGreenSolidButton"
                                type="submit"
                                className="btn btn-default "
                                startIcon={<AddIcon />}
                                onClick={this.addMultipleContactFromGroup.bind(this)}
                              >
                                Add contacts to target group
                              </Button>
                            )} &nbsp; &nbsp;
                            <span className="me-1">
                              <TextField
                                id="standard-search"
                                placeholder="Search"
                                type="text"
                                variant="standard"
                                value={this.state.searchText}
                                onChange={this.onSearchChange.bind(this)}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <IconButton
                                        onClick={this.state.searchBys === "Group" ? this.getContactsList.bind(
                                          this,
                                          this.state.smsGroup,
                                          this.state.pageNo,
                                          this.state.pageSize
                                        ) : this.getActivityContactsList.bind(
                                          this,
                                          this.state.activity,
                                          this.state.pageNo,
                                          this.state.pageSize
                                        )}
                                      >
                                        <SearchIcon />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        onClick={() => {
                                          this.setState({ searchText: "" }, () => {
                                            this.state.selectedTab === 2 ? this.getContactsList.bind(
                                              this,
                                              this.state.smsGroup,
                                              this.state.pageNo,
                                              this.state.pageSize
                                            ) : this.getActivityContactsList.bind(
                                              this,
                                              this.state.activity,
                                              this.state.pageNo,
                                              this.state.pageSize
                                            )
                                          });
                                        }}
                                        disabled={!this.state.searchText}
                                      >
                                        <ClearIcon
                                          style={{
                                            opacity: this.state.searchText ? 1 : 0.4,
                                            fontSize: "1.25rem",
                                            color: "#353538",
                                          }}
                                        />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                      {this.renderTable("pending")}
                    </div>
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div className="row">
                <div className="col">
                  <div className="col md-12">
                    <div className="card rounded-0">
                      <div
                        className="row justify-content-between"
                        style={{ padding: "0.6em 1.2rem" }}
                      >
                        <div className="d-flex col-12 col-lg-3 col-xl-3" style={{ width: this.businessDomain === BUSINESS_DOMAIN.eventText ? "274px" : "244px" }}>
                          <div className="col-12 d-flex">
                            <span className="totalResults me-4" style={{ fontSize: "14px" }}>
                              Contacts: {Utils.formatWithCommas(this.state.totalRecords)}
                            </span>
                          </div>
                        </div>
                        <div className="col-12 col-lg-2 col-xl-2 p-0">
                          <Autocomplete
                            id="size-small-outlined"
                            size="small"
                            fullWidth
                            disableClearable
                            autoComplete="off"
                            options={this.state.smsGroupList}
                            value={this.state.smsGroup}
                            getOptionLabel={(option) => option.name}
                            defaultValue={this.state.smsGroup}
                            onChange={(event, value) => {
                              this.handleGroupsChange(value);
                            }}
                            inputprops={{
                              style: { textTransform: "capitalize" },
                            }}
                            renderOption={(props, option) => (
                              <li
                                {...props}
                                style={{
                                  padding: "5px 15px",
                                }}
                              >
                                {option.name}
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Please Select"
                                variant="outlined"
                                size="small"
                                className="autoComplete"
                                style={{ background: "#fff", top: "0px" }}
                              />
                            )}
                          />
                        </div>
                        <div className="d-flex col-12 col-lg-7 col-xl-7 text-end align-self-center">
                          <div className="col-sm-12 text-end align-self-center">
                            {this.state.isSelected && (
                              <Button
                                id="ptsGreenSolidButton"
                                type="submit"
                                className="btn btn-default "
                                startIcon={<AddIcon />}
                                onClick={this.addMultipleContactFromGroup.bind(this)}
                              >
                                Add contacts to target group
                              </Button>
                            )} &nbsp; &nbsp;
                            <span className="me-1">
                              <TextField
                                id="standard-search"
                                placeholder="Search"
                                type="text"
                                variant="standard"
                                value={this.state.searchText}
                                onChange={this.onSearchChange.bind(this)}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <IconButton
                                        onClick={this.state.searchBys === "Group" ? this.getContactsList.bind(
                                          this,
                                          this.state.smsGroup,
                                          this.state.pageNo,
                                          this.state.pageSize
                                        ) : this.getActivityContactsList.bind(
                                          this,
                                          this.state.activity,
                                          this.state.pageNo,
                                          this.state.pageSize
                                        )}
                                      >
                                        <SearchIcon />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        onClick={() => {
                                          this.setState({ searchText: "" }, () => {
                                            this.state.selectedTab === 2 ? this.getContactsList.bind(
                                              this,
                                              this.state.smsGroup,
                                              this.state.pageNo,
                                              this.state.pageSize
                                            ) : this.getActivityContactsList.bind(
                                              this,
                                              this.state.activity,
                                              this.state.pageNo,
                                              this.state.pageSize
                                            )
                                          });
                                        }}
                                        disabled={!this.state.searchText}
                                      >
                                        <ClearIcon
                                          style={{
                                            opacity: this.state.searchText ? 1 : 0.4,
                                            fontSize: "1.25rem",
                                            color: "#353538",
                                          }}
                                        />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                      {this.renderTable("group")}
                    </div>
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div className="row">
                <div className="col">
                  <div className="col md-12">
                    <div className="card rounded-0">
                      <div
                        className="row justify-content-between"
                        style={{ padding: "0.6em 1.2rem" }}
                      >
                        <div className="d-flex col-12 col-lg-4 col-xl-4" style={{ width: this.businessDomain === BUSINESS_DOMAIN.eventText ? "366px" : "316px" }}>
                          <div className="col-12 d-flex">
                            <span className="totalResults me-4" style={{ fontSize: "14px" }}>
                              Contacts: {Utils.formatWithCommas(this.state.totalRecords)}
                            </span>
                          </div>
                        </div>
                        <div className="d-flex col-12 col-lg-2 col-xl-2 p-0">
                          <Autocomplete
                            size="small"
                            fullWidth
                            disableClearable
                            options={this.state.smsActivityList || []}
                            value={this.state.messageName || null}
                            isOptionEqualToValue={(option, value) =>
                              option?.id === value?.id
                            }
                            getOptionLabel={(option) => {
                              const label = option?.messageKeyword
                                ? `${option.messageName} (${option.messageKeyword})`
                                : option?.messageName || "";

                              return Utils.truncateString(label, 25);
                            }}
                            onChange={(event, value) => {
                              this.handleMessageNameChange(value);
                            }}
                            renderOption={(props, option) => (
                              <li {...props} style={{ padding: "5px 15px" }}>
                                {option.messageName}
                                {option.messageKeyword && ` (${option.messageKeyword})`}
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Please Select"
                                variant="outlined"
                                size="small"
                                className="autoComplete"
                                style={{ background: "#fff", top: "0px" }}
                              />
                            )}
                          />
                        </div>
                        <div className="d-flex col-12 col-lg-5 col-xl-5 text-end align-self-center">
                          <div className="col-sm-12 text-end align-self-center">
                            {this.state.isSelected && (
                              <Button
                                id="ptsGreenSolidButton"
                                type="submit"
                                className="btn btn-default "
                                startIcon={<AddIcon />}
                                onClick={this.addMultipleContactFromGroup.bind(this)}
                              >
                                Add contacts to target group
                              </Button>
                            )} &nbsp; &nbsp;
                            <span className="me-1">
                              <TextField
                                id="standard-search"
                                placeholder="Search"
                                type="text"
                                variant="standard"
                                value={this.state.searchText}
                                onChange={this.onSearchChange.bind(this)}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <IconButton
                                        onClick={this.state.searchBys === "Group" ? this.getContactsList.bind(
                                          this,
                                          this.state.smsGroup,
                                          this.state.pageNo,
                                          this.state.pageSize
                                        ) : this.getActivityContactsList.bind(
                                          this,
                                          this.state.activity,
                                          this.state.pageNo,
                                          this.state.pageSize
                                        )}
                                      >
                                        <SearchIcon />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        onClick={() => {
                                          this.setState({ searchText: "" }, () => {
                                            this.state.selectedTab === 2 ? this.getContactsList.bind(
                                              this,
                                              this.state.smsGroup,
                                              this.state.pageNo,
                                              this.state.pageSize
                                            ) : this.getActivityContactsList.bind(
                                              this,
                                              this.state.activity,
                                              this.state.pageNo,
                                              this.state.pageSize
                                            )
                                          });
                                        }}
                                        disabled={!this.state.searchText}
                                      >
                                        <ClearIcon
                                          style={{
                                            opacity: this.state.searchText ? 1 : 0.4,
                                            fontSize: "1.25rem",
                                            color: "#353538",
                                          }}
                                        />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                      {this.renderTable("messages")}
                    </div>
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div className="row">
                <div className="col">
                  <div className="col md-12">
                    <div className="card rounded-0">
                      <div
                        className="row justify-content-between"
                        style={{ padding: "0.6em 1.2rem" }}
                      >
                        <div className="d-flex col-12 col-lg-4 col-xl-4" style={{ width: this.businessDomain === BUSINESS_DOMAIN.eventText ? "496px" : "530px" }}>
                          <div className="col-12 d-flex">
                            <span className="totalResults me-4" style={{ fontSize: "14px" }}>
                              Contacts: {Utils.formatWithCommas(this.state.totalRecords)}
                            </span>
                          </div>
                        </div>
                        <div className="d-flex col-12 col-lg-2 col-xl-2 p-0">
                          <Autocomplete
                            size="small"
                            fullWidth
                            disableClearable
                            options={
                              this.state.smsActivityList
                                ?.filter(opt => opt.messageKeyword?.trim())
                                .sort((a, b) => a.messageKeyword.localeCompare(b.messageKeyword)) || []
                            }
                            value={this.state.messageKeyword || null}
                            isOptionEqualToValue={(option, value) =>
                              option?.id === value?.id
                            }

                            // getOptionLabel={(option) =>
                            //   option?.messageName
                            //     ? `${option.messageKeyword} (${option.messageName})`
                            //     : option?.messageKeyword || ""
                            // }

                            getOptionLabel={(option) => {
                              const label = option?.messageName
                                ? `${option.messageKeyword} (${option.messageName})`
                                : option?.messageKeyword || "";

                              return Utils.truncateString(label, 25);
                            }}
                            onChange={(event, value) => {
                              this.handleMessageKeywordChange(value);
                            }}
                            renderOption={(props, option) => (
                              <li {...props} style={{ padding: "5px 15px" }}>
                                {option.messageKeyword}
                                {option.messageName && ` (${option.messageName})`}
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Please Select"
                                variant="outlined"
                                size="small"
                                className="autoComplete"
                                style={{ background: "#fff", top: "0px" }} />
                            )}
                          />
                        </div>
                        <div className="d-flex col-12 col-lg-5 col-xl-5 text-end align-self-center" style={{ width: "490px" }}>
                          <div className="col-sm-12 text-end align-self-center">
                            {this.state.isSelected && (
                              <Button
                                id="ptsGreenSolidButton"
                                type="submit"
                                className="btn btn-default "
                                startIcon={<AddIcon />}
                                onClick={this.addMultipleContactFromGroup.bind(this)}
                              >
                                Add contacts to target group
                              </Button>
                            )} &nbsp; &nbsp;
                            <span className="me-1">
                              <TextField
                                id="standard-search"
                                placeholder="Search"
                                type="text"
                                variant="standard"
                                value={this.state.searchText}
                                onChange={this.onSearchChange.bind(this)}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <IconButton
                                        onClick={this.state.searchBys === "Group" ? this.getContactsList.bind(
                                          this,
                                          this.state.smsGroup,
                                          this.state.pageNo,
                                          this.state.pageSize
                                        ) : this.getActivityContactsList.bind(
                                          this,
                                          this.state.activity,
                                          this.state.pageNo,
                                          this.state.pageSize
                                        )}
                                      >
                                        <SearchIcon />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        onClick={() => {
                                          this.setState({ searchText: "" }, () => {
                                            this.state.selectedTab === 2 ? this.getContactsList.bind(
                                              this,
                                              this.state.smsGroup,
                                              this.state.pageNo,
                                              this.state.pageSize
                                            ) : this.getActivityContactsList.bind(
                                              this,
                                              this.state.activity,
                                              this.state.pageNo,
                                              this.state.pageSize
                                            )
                                          });
                                        }}
                                        disabled={!this.state.searchText}
                                      >
                                        <ClearIcon
                                          style={{
                                            opacity: this.state.searchText ? 1 : 0.4,
                                            fontSize: "1.25rem",
                                            color: "#353538",
                                          }}
                                        />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                      {this.renderTable("keywords")}
                    </div>
                  </div>
                </div>
              </div>
            </TabPanel>
          </Tabs>
        </div >
        <div className="row mt-3 mb-3">
          <div className="col-12 position-relative">
            <div className="position-absolute start-0 ms-3">
              <BackButton
                type="button"
                style={{ backgroundColor: "#162c50", color: "#fff" }}
                variant="contained"
                onClick={this.viewCancel.bind(this)}
              >
                Back
              </BackButton>
            </div>
            {this.state.smsContactList.length > 10 &&
              <div className="text-center">
                {this.state.isSelected && (
                  <Button
                    id="ptsGreenSolidButton"
                    type="submit"
                    className="btn btn-default"
                    startIcon={<AddIcon />}
                    onClick={this.addMultipleContactFromGroup.bind(this)}
                  >
                    Add contacts to target group
                  </Button>
                )}
              </div>
            }
          </div>
        </div>
      </>
    );
  }
}
export default withRouter(ContactFromOtherGroup);
